import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle, NgbModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FaBusinessAreaIconsService } from 'app/shared/fa-business-area-icons/fa-business-area-icons.service';
import { SharedModule } from 'app/shared/shared.module';
import { BaseNotificationWidget } from '../base-notification-widget';

@Component({
    selector: 'pcg-dashboard-notifications-widget',
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        NgbDropdown,
        NgbDropdownToggle,
        NgbDropdownMenu,
        NgbTooltip,
        FontAwesomeModule,
        SharedModule,
    ],
    templateUrl: './notifications-widget.component.html',
    styleUrl: './notifications-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardNotificationsWidgetComponent extends BaseNotificationWidget implements OnInit {

    readonly baService = inject(FaBusinessAreaIconsService);

    readonly isSideNav = input(false);

    override PAGE_SIZE = 5;

    ngOnInit(): void {
        this.initNotifications();
    }

    /**
     * Override base scroll: only auto-load more on mobile for the sidenav widget.
     */
    override onScroll(event: Event): void {
        const element = event.target as HTMLElement;
        const atBottom = Math.abs(element.scrollHeight - element.scrollTop - element.clientHeight) < 1;
        this.isScrolledToBottom.set(atBottom);

        if (
            this.navService.isMobile()
            && element.scrollTop + element.clientHeight >= element.scrollHeight - this.SCROLL_OFFSET
        ) {
            if (this.hasMoreNotifications()) {
                this.showMore();
            }
        }
    }
}